
import gql from 'graphql-tag'

// 创建管理员
export const createUser = gql`
  mutation($input: NewUserInput!) {
    createUser(input: $input) {
      id
      username
      phone
      role
    }
  }
`

// 更新管理员
export const updateUser = gql`
  mutation($input: EditUserInput!, $userId: Int!) {
    updateUser(input: $input, userId: $userId) {
      id
      username
      phone
      role
    }
  }
`

// 删除管理员
export const deleteUser = gql`
  mutation($userId: Int!) {
    deleteUser(userId: $userId)
  }
`

// 查询管理员列表
export const findManagers = gql`
  query($where: UsersFindFilter, $order: [UsersFindOrder!], $paging: PagingQuery) {
    findManagers(
      where: $where,
      order: $order,
      paging: $paging
    ) {
      users {
        id
        username
        phone
        role
      }
      paging {
        totalCount
        take
        currentOffset
      }
    }
  }
`

export const exportManagersList = gql`
  query($order: [UsersFindOrder!],$where: UsersFindFilter) {
    exportManagersList(
      order: $order,
      where: $where
    ) {
      fileName
      contentB64
    }
  }
`
